// Import all actions
import * as actions from "../actions/userActions";

export const initialState = "";

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_USER:
      localStorage.setItem("userName", action.payload);
      return action.payload;
    default:
      return state;
  }
}
